import Card from 'components/card/Card'
import React from 'react'
import { Typography } from 'antd'

export default function CardHeaderForm({
  title,
  size = 'text-xl',
}: {
  title: string
  size?: 'text-xl' | 'text-medium'
}) {
  return (
    <Card.Header className="flex pb-0 mb-9">
      <div className="border-2 border-solid border-[#3C5337] rounded-r-sm"></div>
      <Typography.Title level={3} className={`${size} font-bold text-black m-0  px-4`}>
        {title}
      </Typography.Title>
    </Card.Header>
  )
}
